import { render } from "./FaAcadia.vue?vue&type=template&id=27725ac1"
import script from "./FaAcadia.vue?vue&type=script&lang=js"
export * from "./FaAcadia.vue?vue&type=script&lang=js"

import "./FaAcadia.vue?vue&type=style&index=0&id=27725ac1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__